import { CostReportDateRangePicker } from './CostReportDateRangePicker';

import { CostReportPriceTypeSelect } from './CostReportPriceTypeSelect';
import { Stack } from '@cast/design-system';

type Props = {
  noPriceTypeSelector?: boolean;
};

export const CostReportControls = (props: Props) => {
  return (
    <Stack direction="row" gap={8} flexWrap="nowrap" data-testid="controls">
      {!props.noPriceTypeSelector && <CostReportPriceTypeSelect />}
      <CostReportDateRangePicker />
    </Stack>
  );
};
